/*
 * SPDX-FileCopyrightText: 2024 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CmsConfig, I18nModule, provideConfig, UrlModule } from '@spartacus/core';
import { CustomProductReferencesComponent } from './product-references.component';
import { CustomCarouselModule } from '../../carousel/carousel.module';
import { CustomMediaModule } from '../../../media/media.module';
import { CarouselModule } from 'primeng/carousel';
import { CustomProductCarouselModule } from '../product-carousel/product-carousel.module';
import { CustomProductCarouselItemComponent } from '../product-carousel-item/product-carousel-item.component';

@NgModule({
  imports: [
    CommonModule,
    I18nModule,
    CustomCarouselModule,
    CustomMediaModule,
    RouterModule,
    UrlModule,
    CarouselModule,
    CustomProductCarouselModule,
    CustomProductCarouselItemComponent,
  ],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        ProductReferencesComponent: {
          component: CustomProductReferencesComponent,
        },
      },
    }),
  ],
  declarations: [CustomProductReferencesComponent],
  exports: [CustomProductReferencesComponent],
})
export class CustomProductReferencesModule {}
